import Tooltip from "../../shared-modules/Tooltip";
import { pctLabel } from "./vitalCategories";
import styles from "./styles.module.css";


const labelMinWidth = (pct) => `${pctLabel(pct).length * 6 + 8}px`;

/**
 * Proportional category-distribution bar for one vital (SCRUM-134 AC5/AC13),
 * modeled on the patient-dashboard HealthChart bar per p.joshi.
 * Hovering shows the per-category percentage breakdown for THIS patient's
 * readings of THIS vital (AC13; no trend column in the tooltip per p.joshi).
 *
 * Trend arrows were dropped this phase: the Category Report API returns no
 * previous-period data, so there is no basis for the up/down comparison.
 */
const CategoryBar = ({ vital }) => {
  if (!vital?.distribution?.length) return null;

  const tooltipContent = (
    <div className={styles.catTooltip}>
      <div className={styles.catTooltipTitle}>{vital.label}</div>
      <div className={styles.catTooltipBody}>
        {vital.distribution.map((d) => (
          <div key={d.key} className={styles.catTooltipRow}>
            <span
              className={styles.catDot}
              style={{ backgroundColor: d.color }}
            />
            <span className={styles.catTooltipLabel}>{d.label}</span>
            <span className={styles.catTooltipPct}>{pctLabel(d.pct)}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <Tooltip
      content={tooltipContent}
      position="top"
      arrow={false}
      tooltipStyle={{
        backgroundColor: "#fff",
        borderRadius: 10,
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.25)",
        padding: 0,
        minWidth: 0,
      }}
    >
      <div className={styles.catBar}>
        {vital.distribution.map((d) => (
          <div
            key={d.key}
            className={styles.catBarSegment}
            style={{
              width: `${d.pct}%`,
              minWidth: labelMinWidth(d.pct),
              backgroundColor: d.color,
            }}
          >
            <span className={styles.catBarPct}>{pctLabel(d.pct)}</span>
          </div>
        ))}
      </div>
    </Tooltip>
  );
};

export default CategoryBar;
